(function (angular) {
    'use strict';

    /**
     * Template filter that allows you to truncate a string
     * eg 'wejkfbkwf' | truncate: 50: '...See more inside!'
     *
     * @param {String} str
     * @param {Number?80} length
     * @param {String:'...'} append
     */
    function truncateFilter(str, length, append) {
        var length = length || 80;
        var append = append || '...';
        var appendString = str.length >= length ? append : '';
        str = str.slice(0, length);
        return str + appendString;
    }

    angular.module('app')
        .filter('truncate', function () {
            return truncateFilter;
        });
}(angular));
